import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.function.name.js";
// Copyright 2017-2022 @polkadot/keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { nobody } from "./pair/nobody.js";
import { createTestKeyring } from "./testing.js";
export function createTestPairs(options) {
  var isDerived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var keyring = createTestKeyring(options, isDerived);
  var pairs = keyring.getPairs();
  var map = {
    nobody: nobody()
  };

  var _iterator = _createForOfIteratorHelper(pairs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      map[p.meta.name] = p;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return map;
}